<template>
  <g>
    <g>
      <path
        d="M256.55,428.956c-22.895,0-41.522,18.627-41.522,41.522c0,22.895,18.627,41.522,41.522,41.522
			c22.895,0,41.522-18.627,41.522-41.522C298.072,447.583,279.445,428.956,256.55,428.956z M256.55,491.602
			c-11.647,0-21.124-9.477-21.124-21.125c0-11.647,9.476-21.124,21.124-21.124c11.648,0,21.124,9.477,21.124,21.125
			S268.197,491.602,256.55,491.602z"
      />
    </g>
  </g>
  <g>
    <g>
      <path
        d="M256,0C169.169,0,98.527,70.642,98.527,157.473c0,22.935,18.659,41.594,41.594,41.594s41.594-18.659,41.594-41.594
			c0-40.961,33.324-74.284,74.284-74.284s74.284,33.322,74.284,74.283S296.96,231.755,256,231.755
			c-22.935,0-41.594,18.659-41.594,41.594v97.041c0,22.935,18.659,41.594,41.594,41.594s41.594-18.658,41.594-41.594v-61.025
			c31.373-8.622,59.702-27.049,80.458-52.489c22.841-27.995,35.42-63.298,35.42-99.404C413.473,70.642,342.831,0,256,0z
			 M285.224,291.412c-4.687,1.022-8.028,5.17-8.028,9.966v69.014c0,11.687-9.509,21.196-21.196,21.196
			c-11.687,0-21.196-9.509-21.196-21.196V273.35c0-11.687,9.509-21.196,21.196-21.196c52.208,0,94.682-42.474,94.682-94.681
			S308.208,62.79,256,62.79s-94.682,42.475-94.682,94.682c0,11.687-9.509,21.196-21.196,21.196s-21.196-9.509-21.196-21.196
			c0-75.583,61.491-137.074,137.074-137.074s137.074,61.491,137.074,137.073C393.074,221.461,347.716,277.792,285.224,291.412z"
      />
    </g>
  </g>
  <g>
    <g>
      <path
        d="M256,299.857c-5.633,0-10.199,4.566-10.199,10.199v59.155c0,5.633,4.566,10.199,10.199,10.199
			c5.633,0,10.199-4.566,10.199-10.199v-59.155C266.199,304.423,261.633,299.857,256,299.857z"
      />
    </g>
  </g>
  <g>
    <g>
      <path
        d="M256,263.139c-5.633,0-10.199,4.566-10.199,10.199v9.179c0,5.633,4.566,10.199,10.199,10.199
			c5.633,0,10.199-4.566,10.199-10.199v-9.179C266.199,267.706,261.633,263.139,256,263.139z"
      />
    </g>
  </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
  <g> </g>
</template>
